/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const InfrastructureType = {
    ParkingSpace: 'ParkingSpace',
    ParkingZone: 'ParkingZone',
    ParkingLot: 'ParkingLot'
} as const;
export type InfrastructureType = typeof InfrastructureType[keyof typeof InfrastructureType];

